import React from "react";

export const Gym: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg {...props} width="89" height="75" viewBox="0 0 89 75" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M75.6375 48.225L81 42.8625L75.6375 37.5L62.25 50.8875L30.1125 18.75L43.5 5.3625L38.1375 0L32.775 5.3625L27.4125 0L19.3875 8.025L14.025 2.6625L8.6625 8.025L14.025 13.3875L6 21.4125L11.3625 26.775L6 32.1375L11.3625 37.5L24.75 24.1125L56.8875 56.25L43.5 69.6375L48.8625 75L54.225 69.6375L59.5875 75L67.6125 66.975L72.975 72.3375L78.3375 66.975L72.975 61.6125L81 53.5875L75.6375 48.225Z" fill="currentColor"/>
</svg>
);
